import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formats a number using German locale conventions:
 * - Dot (.) as thousand separator
 * - Comma (,) as decimal separator
 *
 * @param value The number to format.
 * @param fixed Number of digits after the decimal point (0–20). If set to -1, all digits are shown as-is. Default is 2.
 * @returns The formatted number string.
 */
export function formatGermanNumber(value: number, fixed = 2): string {
  let formatted: string;
  if (fixed < 0) {
    formatted = value.toString();
  } else {
    formatted = value.toFixed(fixed);
  }
  const [integerPart, decimalPart] = formatted.split('.');
  const withThousandDots = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return decimalPart !== undefined ? `${withThousandDots},${decimalPart}` : withThousandDots;
}

@Pipe({
  name: 'germanNumber',
})
export class GermanNumberPipe implements PipeTransform {
  transform(value: number, fixed = 2): string {
    return formatGermanNumber(value, fixed);
  }
}
